import { getFlowConfig } from '../flow-initial/getFlowConfig';
export const getSignupApiEndpoint = path => {
  const signupApiFlowPath = getFlowConfig().signupApiFlowPath;
  return `/signup/v1/${signupApiFlowPath}/${path}`;
};